<template>
    <h2 class="d-inline">{{ $trans.get('__JSON__.Open projects') }}
        <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge" style="font-size: 0.7rem; transform: translateY(-0.7rem);">
        {{ getCountProjectsOpen() }} </div> </h2>
    <table class="table table-striped hover-zoom">
        <thead>
            <tr>
            <th role="button" @click.prevent="sortColumn = 'project_name'">
                {{ $trans.get('__JSON__.Projectname') }}
                <i v-if="sortColumn == 'project_name'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'employee'">
                {{ $trans.get('__JSON__.Employee') }}
                <i v-if="sortColumn == 'employee'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'intime'">
                {{ $trans.get('__JSON__.Date') }}
                <i v-if="sortColumn == 'intime'" class="fa fa-sort-asc"></i>
            </th>
            <th>
                {{ $trans.get('__JSON__.In') }}
            </th>
            <th>
                {{ $trans.get('__JSON__.Out') }}
            </th>
            </tr>   
        </thead>
        <tbody>
            <tr v-for="projectOpen in sortedProjectsOpen" :key="'et-' + projectOpen.id">
                <td>
                    {{ getProjectName(projectOpen) }}
                </td>
                <td>
                    {{ makeFullname(projectOpen.history_employee.lastname, projectOpen.history_employee.forename) }}
                </td>
                <td>  <i v-if="isBeforeYesterday(projectOpen.intime)" class="fa fa-warning text-danger"
                        v-tooltip title="Zeitstempel älter als 48h!"></i>&nbsp;
                    {{ toYMDFormat(projectOpen.intime) }}
                </td>
                <td>
                    {{ toHMSFormat(projectOpen.intime) }}
                </td>
                <td>
                    <div class="input-group"><input v-model="projectOpen.outtime" class="form-control form-control-xs"
                            type="time" name="out" required>
                        <button class="btn btn-primary" @click="updateStamp(projectOpen)">{{ $trans.get('__JSON__.Set')
                            }}</button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>

    <Teleport to="body">
        <div class=" modal modal-fade" id="errorModal" tabindex="-1" role="dialog" aria-labelledby="mediumModalLabel"
            aria-hidden="false">
            <div class="modal-dialog modal-sm ">
                <div class="modal-content">
                    <div class=" modal-header ">
                        <div class="row">
                            <div class="col-12">
                                <h2>{{ $trans.get('__JSON__.Error on save') }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="text-center modal-body" id="mediumBody">
                        <span class="text-center material-symbols-outlined material-symbols-error">
                                    error
                                </span>
                            <div class="text-center alert alert-block alert-danger">
                            <h4 class="text-center">{{ this.projectOpen_error }}</h4>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" data-bs-dismiss="modal">{{ $trans.get('__JSON__.Confirm') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>


<style>
.material-symbols-error {
    font-size: 128px !important;
    color: coral !important;
  font-variation-settings: 
  'FILL' 0,
  'wght' 500,
  'GRAD' 200,
  'opsz' 48 !important;
} 
</style>

<script>
import getProjectsOpen from "../composables/projectsOpen";

export default {

    name: "ProjectsOpen",

    props: {
        monitor_others: Boolean,
        view_locations: Object,
    },
    setup(props) {
        const { projectsOpen, projectOpen_error, loadProjectsOpen, closeProjectOpen } = getProjectsOpen();
        loadProjectsOpen(props.monitor_others, props.view_locations);

        return { projectsOpen, projectOpen_error, loadProjectsOpen, closeProjectOpen };
    },
    data() {
        return {
            sortColumn: 'created_at',
            counted: null,
        };
    }, 
    created() {
        let refreshtime =  600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData,refreshtime)
    },
    computed: {

        sortedProjectsOpen() {
            if (!this.projectsOpen) {
                $('#projectsOpenContainer').css('display', 'none');
                return null;
            }
            if (this.projectsOpen.length == 0) {
                $('#projectsOpenContainer').css('display', 'none');
                return null;
            }
            $('#projectsOpenContainer').css('display', 'block');
            return this.projectsOpen.sort(this.compareProjectsOpen);
        }
    },
    methods: {
        formatDate(dateString) { // mm.d.yyyy

            if (dateString == null) {
                return null;
            }
            const date = new Date(dateString);

            return date.toLocaleDateString().slice(0, 10) + ', ' + date.toLocaleTimeString();
        },
        toYMDFormat(dateString) { // yyyy-mm-dd
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd;

            return formattedDate;

        },
        toYMDHMFormat(dateString) { // yyyy-mm-dd hh:mi
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');
            var hh = date.getHours().toString().padStart(2, '0');
            var mi = date.getMinutes().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + mi;

            return formattedDate;

        },
        toHMSFormat(dateString) { // yyyy-mm-dd hh:mi
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var hh = date.getHours().toString().padStart(2, '0');
            var mi = date.getMinutes().toString().padStart(2, '0');
            var ss = date.getSeconds().toString().padStart(2, '0');

            var formattedDate = hh + ':' + mi + ':' + ss;

            return formattedDate;

        },
        compareProjectsOpen(a, b) {
            if (this.sortColumn == 'start_at') {

                if (a.start_at == b.start_at) {
                    return 0;
                }

                if (a.start_at < b.start_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'end_at') {

                if (a.end_at == b.end_at) {
                    return 0;
                }

                if (a.end_at < b.end_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'day') {

                if (a.day == b.day) {
                    return 0;
                }

                if (a.day < b.day) {
                    return -1;
                }

            }

            if (this.sortColumn == 'team') {

                if (a.employee.team_id == b.employee.team_id) {
                    return 0;
                }

                if (a.employee.team_id < b.employee.team_id) {
                    return -1;
                }
            }

            if (this.sortColumn == 'location') {

                if (a.employee.location.id == b.employee.location.id) {
                    return 0;
                }

                if (a.employee.location.id < b.employee.location.id) {
                    return -1;
                }

            }


            if (this.sortColumn == 'employee') {
                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }

                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }

                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }

                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }

                if (a.start_at > b.start_at) {
                    return 1;
                }

                if (a.start_at < b.start_at) {
                    return -1;
                }

                return 0;
            }

            return 0;
        },
        getCountProjectsOpen() {
            if (!this.sortedProjectsOpen) {
                return counted = 0;
            }
            let counted = this.sortedProjectsOpen.length;
            return counted;
        },
        isYesterdayOrBefore(date) {
            var d = new Date();
            d.setDate(d.getDate() - 1);
            if (Date.parse(date) <= Date.parse(d)) {
                return true;
            }
            return false;
        }, isBeforeYesterday(date) {
            var d = new Date();
            d.setDate(d.getDate() - 1);
            if (Date.parse(date) < Date.parse(d)) {
                return true;
            }
            return false;
        },
        isOlderThanFourDays(date) {
            var d = new Date();
            d.setDate(d.getDate() - 4);
            if (Date.parse(date) < Date.parse(d)) {
                return true;
            }
            return false;
        },
        async updateStamp(openProject) {
            this.projectOpen_error = null;
            var outtime = (openProject.outtime + '').split(':'); ;
            openProject.intime = new Date(openProject.intime);
            openProject.outtime = new Date(openProject.intime);
            openProject.outtime.setHours(outtime[0], outtime[1]);


            console.log(openProject.outtime);
            console.log(openProject.intime);
            if (openProject.outtime < openProject.intime) {
                openProject.outtime.setDate(openProject.outtime.getDate() + 1);
            }

            openProject.intime = this.toYMDHMFormat(openProject.intime);
            openProject.outtime = this.toYMDHMFormat(openProject.outtime);

            console.log(openProject.outtime);
            console.log(openProject.intime);

            await (this.closeProjectOpen(openProject));
            if (this.projectOpen_error) {
                console.log("error: ", this.projectOpen_error);
                $("#errorModal").modal("show");
            }
            else {
               // console.log(this.projectsOpen);
                this.projectsOpen = this.projectsOpen.filter(function (value, index, arr) {
                    return value.id != openProject.id;
                });
            }
        },
        makeFullname(lastname, forename) {
            const fullname = lastname + ', ' + forename;
            return fullname;
        },
        getProjectName(projectOpen) {
            //console.log(projectOpen);
            if (_.isNull(projectOpen.project)) {
                return '-';
            }
            if (_.isNull(projectOpen.project.project_type_id)) {
                const projectname = projectOpen.project?.client.name + ' - ';
                return projectname;
            }
            const projectname = projectOpen.project?.client.name + ' - ' + projectOpen.project?.projecttype?.name ?? '';
            return projectname;
        },
        refreshData() {
            this.loadProjectsOpen(this.monitor_others, this.view_locations);
        },

    }
}



</script>